<template>
  <div class="club-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li
          v-for="(tab, index) in tabList"
          :key="index"
          :class="{ active: currentTab === index, empty: isEmpty(tab)}"
          @click="tabIndexChange(index, $event)"
        >
          <a href="#" @click.prevent>
            <div v-html="tab"></div>
          </a>
        </li>
      </ul>
    </div>

    <div v-if="currentTab === 0" class="tab-content">
      <LocalYellowWaveMain />
    </div>
    <div v-if="currentTab === 1" class="tab-content">
      <LocalYellowWaveChallenge />
    </div>
    <div v-if="currentTab === 2" class="tab-content">
      <LocalParticipationEvents />
    </div>
  </div>
</template>

<script>
import {isEmpty} from '@/lib';
import LocalYellowWaveMain from '@/components/Club/LocalYellowWaveMain';
import LocalYellowWaveChallenge from '@/components/Club/LocalYellowWaveChallenge';
import LocalParticipationEvents from '@/components/Club/LocalParticipationEvents';

export default {
  name: 'Csr',
  components: {LocalParticipationEvents, LocalYellowWaveChallenge, LocalYellowWaveMain },
  data() {
    return {
      currentTab: 0,
      tabList: [
        '노란물결',
        '노란물결:<br>전남드래곤즈를 이겨라',
        '노란물결: 지역밀착'
      ],
    };
  },
  mounted() {
    const slider = this.$el.querySelector('.tab-box');

    // 최초 진입 시 중앙 정렬
    this.$nextTick(() => {
      const el = this.$el.querySelectorAll('.tab-btn-list li')[this.currentTab];
      el?.scrollIntoView({
        behavior: 'auto',
        inline: 'center',
        block: 'nearest',
      });
    });

    // PC 드래그 스크롤
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  },
  methods: {
    isEmpty,
    tabIndexChange(index, event) {
      if(index === 6) {
        return false;
      }
      this.currentTab = index;

      // 클릭한 탭 중앙 이동
      this.$nextTick(() => {
        const el = event.currentTarget;
        el?.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      });
    },
  },
};
</script>

<style scoped>
.tab-btn-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: normal !important;
  height: 60px;
}

.tab-box .tab-btn-list li {
  padding: 0 16px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-box .tab-btn-list li a {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0;
  text-align: center;
}

@media (max-width: 959px) {
  .empty {
    width: 20px !important;
    flex: 0 0 20px !important;
  }

  .club-page {
    margin: 0;
  }
  .tab-content {
    margin: 0 20px;
  }
  .tab-box .tab-btn-list li:first-child {
    margin-left: 20px;
  }
  .empty {
    cursor: auto;
    border-top: 0 !important;
    border-right: 0 !important;
    border-bottom: 0 !important;
    width: 20px !important;
    padding: 0 !important;
    display: block;
    flex: 0 0 20px !important;
  }
  .tab-box {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    /* 스크롤바 숨김 */
    scrollbar-width: none;
    -ms-overflow-style: none;

    cursor: grab;
  }

  .tab-box:active {
    cursor: grabbing;
  }

  .tab-box::-webkit-scrollbar {
    display: none;
  }

  .tab-btn-list li {
    flex: 0 0 175px;
    align-content: center;
  }
}
</style>
